import Paragraph from "../../shared/ui/Paragraph/Paragraph";
import { classNames } from "../../shared/lib/classNames/classNames";
import cls from "./Privacy.module.css";

const PrivacyPolicy = () => {
    return (
        <div className="container container--main">
            <section className={classNames(cls.Privacy)}>
                <h1>Privacy Policy</h1>

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `Effective Date: 15/04/2024\nWelcome to https://expresslabapps.com Your privacy is very important to us. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our website.`
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `1. Information We Collect\nWe may collect and process the following types of personal information:`
                    },
                    {
                        type: "list",
                        content: [
                            "Contact details: name, email address, phone number.",
                            "Account information: username, password (stored in encrypted form).",
                            "Technical data: IP address, browser type and version, device type, operating system, time zone, cookies.",
                            "Usage data: pages visited, referral links, time spent on the site, actions taken.",
                            "Payment data (if purchases are available): payment card details or other billing information (processed securely through third-party payment providers).",
                            "Any information you voluntarily provide (e.g., via forms, surveys, or support requests)."
                        ]
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `2. How We Use Your Information\nWe use the data we collect for purposes such as:`
                    },
                    {
                        type: "list",
                        content: [
                            "Operating and maintaining the website.",
                            "Processing transactions, subscriptions, or service requests.",
                            "Communicating with you (responding to inquiries, sending updates or newsletters).",
                            "Improving website functionality, user experience, and analytics.",
                            "Ensuring legal compliance and fulfilling regulatory obligations.",
                            "Preventing fraud and protecting our website and users."
                        ]
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `3. Legal Basis for Processing\nWe process your personal data when:`
                    },
                    {
                        type: "list",
                        content: [
                            "It is necessary to perform a contract with you.",
                            "You have given explicit consent.",
                            "It is required by law.",
                            "It is in our legitimate interest (e.g., to maintain security, improve services), provided your rights are not overridden."
                        ]
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `4. Sharing of Data\nWe may share your personal data with:`
                    },
                    {
                        type: "list",
                        content: [
                            "Service providers (hosting, analytics, payment processors, marketing tools).",
                            "Affiliates and partners, where relevant to providing our services.",
                            "Authorities or regulators, when required by applicable law.",
                            "We take steps to ensure that third parties respect and protect your data."
                        ]
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `5. Data Retention\nWe retain your personal data only as long as necessary for the purposes described in this Privacy Policy, or as required by law. Once no longer needed, data will be securely deleted or anonymized.`
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `6. Cookies and Tracking Technologies\nWe use cookies and similar technologies to:`
                    },
                    {
                        type: "list",
                        content: [
                            "Enable core website functionality.",
                            "Collect analytics and improve performance.",
                            "Personalize user experience.",
                            "Provide advertising or marketing (if applicable).",
                            "You can disable cookies in your browser settings, but this may affect some features of the site."
                        ]
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `7. Your Rights\nDepending on your jurisdiction (e.g., GDPR, CCPA), you may have the right to:`
                    },
                    {
                        type: "list",
                        content: [
                            "Access a copy of the personal data we hold about you.",
                            "Correct inaccurate or incomplete information.",
                            "Request deletion of your data.",
                            "Restrict or object to data processing.",
                            "Receive your data in a portable format.",
                            "Withdraw consent where processing is based on consent.",
                            "To exercise these rights, please contact us using the details below."
                        ]
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `8. Data Security\nWe use appropriate technical and organizational measures to protect your data against unauthorized access, loss, misuse, or disclosure.`
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `9. Children's Privacy\nOur services are not directed to individuals under 18. We do not knowingly collect personal data from children. If we become aware that data was provided by a child without parental consent, we will delete it.`
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `10. Third-Party Links\nOur website may contain links to third-party sites. We are not responsible for their privacy practices. Please review their policies before providing personal data.`
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `11. Changes to This Policy\nWe may update this Privacy Policy from time to time. Any changes will be posted on this page with an updated "Effective Date."`
                    }
                ]} />

                <Paragraph paragraphContent={[
                    {
                        type: "text",
                        content: `12. Contact Us\nIf you have any questions about this Privacy Policy or how we handle your data, please contact us at:\nEmail: info@expresslabapps.com`
                    }
                ]} />
            </section>
        </div>
    )
}

export default PrivacyPolicy;